import { maxDescription, minDescription, validations } from "../../../../../../config/validations/validations";
export const rules: any = {
    name : (field?: string) => [
        validations.required.text(field),
        validations.min.text(minDescription),
        validations.max.text(maxDescription),
    ]
}